<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <span class="font-weight-bold">Logs de Comissoes</span>
      <b-button v-b-toggle="collapseId" size="sm" variant="outline-secondary">
        {{ isOpen ? 'Ocultar' : 'Mostrar' }}
      </b-button>
    </b-card-header>
    <b-collapse :id="collapseId" v-model="isOpen">
      <b-card-body>
        <StateRenderer
          :loading="report.loading"
          :error="report.error"
          :data="logs"
        >
          <b-alert
            v-if="logs.length === 0"
            show
            variant="secondary"
            class="text-center"
          >
            Nenhum log encontrado no periodo selecionado
          </b-alert>
          <template v-else>
            <div class="commission-logs-scroll">
              <b-table
                :fields="fields"
                :items="logs"
                striped
                hover
                small
                responsive
                stacked="md"
                class="mb-0"
              >
                <template #cell(createdAt)="{ item }">
                  {{ item.createdAt | formatStandardDateTime }}
                </template>
                <template #cell(reason)="{ item }">
                  {{ formatReason(item.reason) }}
                </template>
                <template #cell(points)="{ item }">
                  <b-badge :variant="pointsVariant(item.points)">
                    {{ item.points }}
                  </b-badge>
                </template>
                <template #cell(amount)="{ item }">
                  {{ item.amount | formatCurrency }}
                </template>
                <template #cell(periodMinutes)="{ item }">
                  {{ formatMinutes(item.periodMinutes) }}
                </template>
              </b-table>
            </div>
          </template>
        </StateRenderer>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import StateRenderer from '@/components/StateRenderer'
import { formatStandardDateTime } from '@/helpers/date'
import { formatCurrency } from '@/helpers/numbers'

const REASON_LABELS = {
  rent_started: 'Aluguel iniciado',
  rent_canceled: 'Aluguel cancelado',
  rent_recovered: 'Aluguel reaberto',
  rent_closed: 'Aluguel encerrado',
  rent_rescued: 'Aluguel resgatado',
  product_sale: 'Venda de produto',
  manual_adjustment: 'Ajuste manual'
}

export default {
  name: 'CommissionsLogList',
  components: { StateRenderer },
  filters: {
    formatStandardDateTime,
    formatCurrency
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.defaultOpen
    }
  },
  computed: {
    collapseId() {
      return `commissions-logs-${this._uid}`
    },
    fields() {
      return [
        { key: 'createdAt', label: 'Data' },
        { key: 'userName', label: 'Funcionario' },
        { key: 'reason', label: 'Motivo' },
        {
          key: 'points',
          label: 'Vendas',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'amount',
          label: 'Valor',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'periodMinutes',
          label: 'Periodo',
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ]
    },
    logs() {
      const data = this.report?.data || {}
      if (Array.isArray(data.logs)) return data.logs
      if (Array.isArray(data)) return data
      return []
    }
  },
  methods: {
    formatReason(reason) {
      return REASON_LABELS[reason] || reason || '-'
    },
    pointsVariant(points) {
      return points < 0 ? 'danger' : 'success'
    },
    formatMinutes(value) {
      const minutes = Number(value)
      if (!Number.isFinite(minutes) || minutes <= 0) return '0 min'
      const totalMinutes = Math.round(minutes)
      const hours = Math.floor(totalMinutes / 60)
      const rest = totalMinutes % 60
      if (hours > 0) {
        return `${hours}h ${rest}min`
      }
      return `${rest} min`
    }
  }
}
</script>

<style scoped>
.commission-logs-scroll {
  max-height: 440px;
  overflow: auto;
}

@media (max-width: 767.98px) {
  .commission-logs-scroll {
    max-height: 520px;
  }
}
</style>
